import { render, staticRenderFns } from "./EffectiveFileTable.vue?vue&type=template&id=f99c7822&scoped=true"
import script from "./EffectiveFileTable.vue?vue&type=script&lang=js"
export * from "./EffectiveFileTable.vue?vue&type=script&lang=js"
import style0 from "./EffectiveFileTable.vue?vue&type=style&index=0&id=f99c7822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99c7822",
  null
  
)

export default component.exports